<div class="container report-page">
    <div class="row">
        <div class="col-md-12 col-lg-12 col-12">
            <div class="report-header">
                <h1 class="student-title">Student Well Being Report</h1>
                <div class="report-header__actions">
                   
                    <button type="button" class="report-download-btn" (click)="exportExcel()" 
                        aria-label="Download Excel">
                      Download Excel  <img src="assets/image/vscode-icons_file-type-excel.svg" alt="" />
                    </button>
                 
                    <button type="button" class="report-download-btn" (click)="exportPdf()" 
                        aria-label="Download PDF">
                      Question paper Download PDF <img src="assets/image/pdficon.svg" alt="" />
                    </button>
                    <button type="button" class="report-filter-btn" (click)="toggleFilter($event)"
                        aria-label="Open filters">
                       Filters <i class="fa-solid fa-sliders" aria-hidden="true"></i>
                    </button>
                </div>
            </div>

            <div class="report-filter" *ngIf="filterOpen" (click)="onReportFilterClick($event)">
                <h2 class="report-filter__title">Filters</h2>

                <div class="report-filter__field">
                    <label class="report-filter__label" for="reportState">State</label>
                    <div class="report-filter__select-wrap">
                        <input id="reportState" type="text" class="report-filter__select" [(ngModel)]="stateSearch"
                            placeholder="Select State" autocomplete="off" (input)="onStateSearchInput()"
                            (focus)="openStateDropdown()" (click)="$event.stopPropagation(); openStateDropdown()" />
                        <ul class="report-filter__select-options" *ngIf="stateDropdownOpen"
                            (click)="$event.stopPropagation()">
                            <li *ngIf="!filteredStates.length" class="report-filter__select-option--empty">No results
                                found</li>
                            <li *ngFor="let s of filteredStates">
                                <button type="button" class="report-filter__select-option"
                                    [class.report-filter__select-option--active]="selectedStateId === s.stateId"
                                    (click)="selectState(s)">{{ s.stateName }}</button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="report-filter__field">
                    <label class="report-filter__label" for="reportCity">City</label>
                    <div class="report-filter__select-wrap">
                        <input id="reportCity" type="text" class="report-filter__select" [(ngModel)]="citySearch"
                            placeholder="Select City" autocomplete="off" [disabled]="!selectedStateId"
                            (input)="onCitySearchInput()" (focus)="openCityDropdown()"
                            (click)="$event.stopPropagation(); openCityDropdown()" />
                        <ul class="report-filter__select-options" *ngIf="cityDropdownOpen && selectedStateId"
                            (click)="$event.stopPropagation()">
                            <li *ngIf="!filteredCities.length" class="report-filter__select-option--empty">No results
                                found</li>
                            <li *ngFor="let c of filteredCities">
                                <button type="button" class="report-filter__select-option"
                                    [class.report-filter__select-option--active]="selectedCityId === c.cityId"
                                    (click)="selectCity(c)">{{ c.cityName }}</button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="report-filter__field">
                    <label class="report-filter__label" for="reportCampus">Campus</label>
                    <div class="report-filter__select-wrap">
                        <input id="reportCampus" type="text" class="report-filter__select" [(ngModel)]="campusSearch"
                            placeholder="Select Campus" autocomplete="off" [disabled]="!selectedCityId"
                            (input)="onCampusSearchInput()" (focus)="openCampusDropdown()"
                            (click)="$event.stopPropagation(); openCampusDropdown()" />
                        <ul class="report-filter__select-options" *ngIf="campusDropdownOpen && selectedCityId"
                            (click)="$event.stopPropagation()">
                            <li *ngIf="!filteredCampuses.length" class="report-filter__select-option--empty">No results
                                found</li>
                            <li *ngFor="let c of filteredCampuses">
                                <button type="button" class="report-filter__select-option"
                                    [class.report-filter__select-option--active]="selectedCampusId === c.campusId"
                                    (click)="selectCampus(c)">{{ c.campusName }}</button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="report-filter__field">
                    <label class="report-filter__label" for="reportFromDate">From Date</label>
                    <div class="report-filter__date-wrap" (click)="$event.stopPropagation()">
                        <input id="reportFromDate" matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate"
                            class="report-filter__date-input" placeholder="From date" [max]="maxReportDate" />
                        <mat-datepicker-toggle matSuffix [for]="fromPicker"
                            (click)="$event.stopPropagation()"></mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </div>
                </div>

                <div class="report-filter__field">
                    <label class="report-filter__label" for="reportToDate">To Date</label>
                    <div class="report-filter__date-wrap" (click)="$event.stopPropagation()">
                        <input id="reportToDate" matInput [matDatepicker]="toPicker" [(ngModel)]="toDate"
                            class="report-filter__date-input" placeholder="To date" [max]="maxReportDate" />
                        <mat-datepicker-toggle matSuffix [for]="toPicker"
                            (click)="$event.stopPropagation()"></mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </div>
                </div>

                <div class="report-filter__actions">
                    <button type="button" class="report-filter__reset" (click)="resetFilters()">RESET</button>
                    <button type="button" class="report-filter__apply" (click)="applyFilters()"
                        [disabled]="!canApplyFilters">Apply</button>
                </div>
            </div>

            <div class="report-grid-wrap">
                <ag-grid-angular class="ag-theme-alpine report-grid" [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                    [overlayLoadingTemplate]="overlayLoadingTemplate" [rowModelType]="'serverSide'"
                    [pagination]="serverPaginationEnabled" [paginationPageSize]="pageSize" [cacheBlockSize]="pageSize"
                    [maxBlocksInCache]="1" (gridReady)="onGridReady($event)" (cellClicked)="onCellClicked($event)">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>